export const APPCLUST_CATEGORY_TO_SLUG: Record<string, string> = {
  "Speech & Language Therapist": "speech-language-therapists",
  "Occupational Therapist": "occupational-therapists",
  "Physiotherapist": "physio-therapists",
  "ABA Therapist": "aba-therapists",
  "School Readiness Therapists": "school-readiness-therapists",
  "Administration Team": "administration-team",
  "Management Team": "management-team",
};

export const CATEGORY_SLUG_ORDER = [
  "speech-language-therapists",
  "occupational-therapists",
  "physio-therapists",
  "aba-therapists",
  "school-readiness-therapists",
  "administration-team",
  "management-team",
] as const;

/** Team categories omitted from public team pages, menus, and profiles. */
export const HIDDEN_TEAM_CATEGORIES = new Set<string>(["aba-therapists"]);

export function isPublicTeamCategory(slug: string): boolean {
  return !HIDDEN_TEAM_CATEGORIES.has(slug);
}

const CATEGORY_TITLES: Record<string, string> = {
  "speech-language-therapists": "Speech & Language Therapists",
  "occupational-therapists": "Occupational Therapists",
  "physio-therapists": "Physio Therapists",
  "aba-therapists": "ABA Therapists",
  "school-readiness-therapists": "School Readiness Therapists",
  "administration-team": "Administration Team",
  "management-team": "Management Team",
};

export function getCategoryTitle(slug: string): string {
  return CATEGORY_TITLES[slug] || "Our Team";
}

export function getServiceUrl(slug: string): string | null {
  const serviceMap: Record<string, string> = {
    "occupational-therapists": "/services/occupational-therapy",
    "speech-language-therapists": "/services/speech-language-therapy",
    "physio-therapists": "/services/physical-therapy",
    "aba-therapists": "/services/aba-therapy",
    "school-readiness-therapists": "/services/school-readiness-program",
  };
  return serviceMap[slug] || null;
}
